import type { LocaleCatalog, MessageSchema } from '../locale';

/**
 * ============================================================================
 * @altkey/i18n - Deutscher Katalog (de)
 * ============================================================================
 * Implementiert vollständig das `MessageSchema` aus `../locale.ts`. Jeder
 * fehlende oder zusätzliche Schlüssel im Vergleich zum Schema führt zu einem
 * TypeScript-Kompilierungsfehler: dies garantiert, dass der deutsche
 * Katalog zu 100% mit den anderen 4 unterstützten Sprachen synchron bleibt.
 * ============================================================================
 */

const messages: MessageSchema = {
  common: {
    appName: 'AltKey',
    ok: 'OK',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    loading: 'Wird geladen…',
    retry: 'Erneut versuchen',
    close: 'Schließen',
    copy: 'Kopieren',
    copied: 'In die Zwischenablage kopiert',
  },
  pairing: {
    title: 'Verbinde deine Geräte',
    scanQrPrompt: 'Scanne den QR-Code mit deinem Smartphone, um es mit diesem Computer zu koppeln',
    enterCodeManually: 'Oder gib den 6-stelligen Code manuell ein',
    waitingForDesktop: 'Warte auf die Verbindung des Computers…',
    waitingForMobile: 'Warte auf die Verbindung des Smartphones…',
    connected: 'Gerät verbunden',
    disconnected: 'Gerät getrennt',
    expired: 'Die Kopplungssitzung ist abgelaufen. Erstelle einen neuen Code.',
    invalidCode: 'Ungültiger Code. Bitte überprüfen und erneut versuchen.',
    keysExchanged: 'Austausch der Sicherheitsschlüssel abgeschlossen',
    scanDevice: 'Gerät scannen',
    showMyCode: 'Meinen Code zeigen',
    hostingPrompt: 'Scanne diesen Code mit dem anderen Smartphone',
    goBack: 'Torna Indietro',
    disconnectAction: 'Scollega',
    deviceConnected: '🟢 Dispositivo Connesso',
    backToCategories: '← Torna alle Categorie',
  },
  license: {
    proUnlockedPromo:
      'AltKey befindet sich in der weltweit kostenlosen Beta-Phase: alle Pro-Funktionen sind freigeschaltet',
    proUnlockedLicense: 'Pro-Funktionen mit deiner Lizenz freigeschaltet',
    freeTierPrompt: 'Schalte Pro-Funktionen mit einer AltKey-Lizenz frei',
    invalidLicense: 'Der eingegebene Lizenzschlüssel ist ungültig',
    enterLicenseKey: 'Gib deinen Lizenzschlüssel ein',
  },
  search: {
    placeholder: 'Suche nach einem Symbol, Zeichen oder Schlüsselwort…',
    noResults: 'Keine Ergebnisse gefunden',
    resultsCount: '{count} Ergebnisse gefunden',
    filterByCategory: 'Nach Kategorie filtern',
    recentSymbols: 'Zuletzt verwendete Symbole',
  },
  tofuDetector: {
    title: 'Tofu-Erkennung',
    scanning: 'Suche nach fehlenden Zeichen…',
    issuesFound: '{count} nicht darstellbare Zeichen (Tofu) gefunden',
    noIssuesFound: 'Keine fehlenden Zeichen erkannt: alles in Ordnung',
    replaceSuggestion: 'Durch ein kompatibles alternatives Zeichen ersetzen',
  },
  macroGenerator: {
    title: 'Makro-Generator',
    recordMacro: 'Neues Makro aufzeichnen',
    stopRecording: 'Aufzeichnung stoppen',
    saveMacro: 'Makro speichern',
    macroSaved: 'Makro erfolgreich gespeichert',
    deleteMacro: 'Makro löschen',
  },
  aiCanvasInput: {
    title: 'KI-Canvas-Eingabe',
    drawPrompt: 'Zeichne mit dem Finger oder Stift das gesuchte Symbol',
    recognizing: 'Zeichnung wird erkannt…',
    recognitionFailed: 'Das Symbol konnte nicht erkannt werden. Versuche es erneut zu zeichnen.',
    insertSymbol: 'Symbol einfügen',
  },
  settings: {
    title: 'Einstellungen',
    language: 'Sprache',
    theme: 'Design',
    themeLight: 'Hell',
    themeDark: 'Dunkel',
    themeSystem: 'Systemeinstellung folgen',
    startOnBoot: 'Beim Hochfahren des Computers starten',
    notifications: 'Benachrichtigungen',
    about: 'Über',
    version: 'Version {version}',
    checkForUpdates: 'Nach Updates suchen',
    signOut: 'Abmelden',
  },
  home: {
    title: 'Start',
    greeting: 'Hallo, {name}',
    pairWithDesktop: 'Mit Computer koppeln',
    recentActivity: 'Letzte Aktivität',
    quickActions: 'Schnellaktionen',
    noRecentActivity: 'Keine letzte Aktivität vorhanden',
  },
  errors: {
    generic: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.',
    network: 'Verbindungsfehler. Überprüfe dein Netzwerk und versuche es erneut.',
    sessionExpired: 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
    unauthorized: 'Du bist nicht berechtigt, diese Aktion auszuführen.',
    notFound: 'Ressource nicht gefunden.',
  },
};

const catalog: LocaleCatalog = {
  locale: 'de',
  messages,
};

export default catalog;